import React, { useMemo } from 'react';
import { Entity, FilterSections, FiltersValues } from '../types';
import { FilterEntry } from './filterEntry';
import { FilterGroupContainer } from './filterGroupContainer';
import { filterByHierarchy } from './utils';
import classNames from 'classnames';
import { useMobile } from '../context/mobile/mobile.provider';

interface FilterSectionComponentProps {
  section: FilterSections;
  values: FiltersValues;
  onChange: (name: string, values: Entity[]) => void;
  getIsDisabled: (definitionName: string) => boolean;
}

function FilterSection({ section, onChange, getIsDisabled, values }: FilterSectionComponentProps) {
  const { isMobile } = useMobile();
  // Filter section definitions dynamically for hierarchy*
  const filteredDefinitions = useMemo(() => {
    let filteredOptionsMap: Record<string, any> = {};
    return section.ungrouped.definitions.map(def => {
      if (def?.hierarchy?.enabled) {
        const filteredOptions = filterByHierarchy(
          def.hierarchy.name,
          def.hierarchy.level,
          def.hierarchy.parent,
          def.options || [],
          filteredOptionsMap,
          values
        );
        return { ...def, options: filteredOptions };
      }
      return def;
    });
  }, [values, section]);

  return (
    <>
      <h3
        className={classNames('mb-6 font-normal', {
          'border-t border-light pt-4': section.label === 'Features',
          'text-lg': isMobile,
        })}
      >
        {section.label}
      </h3>
      {section?.grouped?.length > 0 && (
        <FilterGroupContainer
          grouped={section.grouped}
          values={values}
          onChange={onChange}
          getIsDisabled={getIsDisabled}
        />
      )}
      {filteredDefinitions.length > 0 &&
        filteredDefinitions.map(def => (
          <FilterEntry
            key={def.name}
            definition={def}
            values={values[def.name]}
            disabled={getIsDisabled(def.name)}
            onChange={onChange}
          />
        ))}
    </>
  );
}

export { FilterSection };
